/**
 * "Identity & authentication" — Core Concepts (ADR-0074).
 * Reconciled from docs/concepts/auth-modes.mdx, idp-config.graphql, the MCP OAuth
 * flow, and the step-up / act-on-behalf surfaces.
 */
import type { DocPageContent } from '../types';

export const IDENTITY_PAGE: DocPageContent = {
  slug: 'identity',
  titleKey: 'docs.concepts.identity.title',
  descriptionKey: 'docs.concepts.identity.description',
  blocks: [
    { kind: 'paragraph', textKey: 'docs.concepts.identity.lead' },

    {
      kind: 'heading',
      level: 2,
      id: 'federation',
      textKey: 'docs.concepts.identity.federation.heading',
    },
    { kind: 'paragraph', textKey: 'docs.concepts.identity.federation.body' },
    {
      kind: 'list',
      itemKeys: [
        'docs.concepts.identity.federation.item.auth0',
        'docs.concepts.identity.federation.item.clerk',
        'docs.concepts.identity.federation.item.cognito',
        'docs.concepts.identity.federation.item.workos',
        'docs.concepts.identity.federation.item.keycloak',
        'docs.concepts.identity.federation.item.entraExternalId',
        'docs.concepts.identity.federation.item.oidc',
      ],
    },

    {
      kind: 'heading',
      level: 2,
      id: 'two-logins',
      textKey: 'docs.concepts.identity.twoLogins.heading',
    },
    { kind: 'paragraph', textKey: 'docs.concepts.identity.twoLogins.body' },

    {
      kind: 'heading',
      level: 2,
      id: 'act-as-user',
      textKey: 'docs.concepts.identity.actAsUser.heading',
    },
    { kind: 'paragraph', textKey: 'docs.concepts.identity.actAsUser.body' },

    { kind: 'heading', level: 2, id: 'step-up', textKey: 'docs.concepts.identity.stepUp.heading' },
    { kind: 'paragraph', textKey: 'docs.concepts.identity.stepUp.body' },

    { kind: 'heading', level: 2, id: 'mcp', textKey: 'docs.concepts.identity.mcp.heading' },
    { kind: 'paragraph', textKey: 'docs.concepts.identity.mcp.body' },

    { kind: 'heading', level: 2, id: 'next', textKey: 'docs.common.nextSteps' },
    {
      kind: 'cardGrid',
      cards: [
        {
          titleKey: 'docs.concepts.identity.next.confirmation.title',
          textKey: 'docs.concepts.identity.next.confirmation.text',
          to: { docSlug: 'confirmation' },
        },
        {
          titleKey: 'docs.concepts.identity.next.browserGate.title',
          textKey: 'docs.concepts.identity.next.browserGate.text',
          to: { docSlug: 'browser-gate' },
        },
      ],
    },
  ],
};
